import type { FC } from "react";

import { Field, FieldError, FieldLabel } from "@recobra/ui/field";
import { Input } from "@recobra/ui/input";

import { getErrorMessage, useFieldContext } from "./context";

const formatRg = (raw: string): string => {
  const value = raw
    .replace(/[^A-Za-z0-9 ./-]/g, "")
    .toUpperCase()
    .slice(0, 20);
  if (/[A-WYZ]/.test(value)) return value;

  const cleaned = value.replace(/[^0-9X]/g, "").slice(0, 9);
  if (cleaned.length <= 2) return cleaned;
  if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
  if (cleaned.length <= 8)
    return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;

  return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}-${cleaned.slice(8, 9)}`;
};

export const RgField: FC<{ label: string; id?: string }> = ({ label, id }) => {
  const field = useFieldContext<string | undefined>();
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  return (
    <Field data-invalid={errorMessage ? "true" : undefined} className="min-w-0">
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <Input
        id={id}
        value={field.state.value ?? ""}
        onChange={(e) => {
          const next = formatRg(e.target.value);
          field.handleChange(next || undefined);
        }}
        onBlur={field.handleBlur}
        maxLength={20}
        aria-invalid={Boolean(errorMessage)}
      />
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </Field>
  );
};
